import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { Observable } from 'rxjs';
import { StoreService } from '../../services/store/store.service';
import { LocalizationService } from '../../services/localization/localization.service';

@Component({
  selector: 'app-checkout-sidebar',
  templateUrl: './checkout-sidebar.component.html',
  styleUrls: ['./checkout-sidebar.component.scss']
})
export class CheckoutSidebarComponent implements OnInit {
  @Input() public content: Entry<any>;
  public selectedPlan$: Observable<any>;
  public selectedPlanTotal$: Observable<any>;
  public selectedPlanDay$: Observable<any>;
  public currentLocale$: Observable<string | undefined>;

  constructor(
    private store: StoreService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit() {
    this.selectedPlan$ = this.store.selectedPlan;
    this.selectedPlanTotal$ = this.store.selectedPlanTotal;
    this.selectedPlanDay$ = this.store.selectedPlanDay;
    this.currentLocale$ = this.localizationService.locale;
  }
}
